import { Image } from '../Image';
import { Figure } from './Figure.styles';

import type { FigureProps } from './Figure.d';

const FigureBase = ({
  alt,
  caption,
  captionAlign = 'center',
  opacity,
  ratio,
  shape = 'square',
  src,
  ...props
}: FigureProps) => (
  <Figure.Component data-testid="figure" {...props}>
    <Figure.Wrapper data-shape={shape}>
      <Image alt={alt} opacity={opacity} ratio={ratio} src={src} />
    </Figure.Wrapper>

    {caption && <Figure.Caption data-align={captionAlign}>{caption}</Figure.Caption>}
  </Figure.Component>
);

export default FigureBase;
